import { GET_PERSONALLOGS } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_PERSONALLOGS:
            return action.payload;
        default:
            return state;
    }
}